import { StartCampaignOrAutomationPage } from "../../../externalComponents/StartCampaignOrAutomation";

const CreateCampaignFromScratchPage = () => {
  return <StartCampaignOrAutomationPage/>;
};

export default CreateCampaignFromScratchPage;